import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './SidebarBrandActions.css';

const {
  FiBookOpen,
  FiCalendar,
  FiChevronDown,
  FiCreditCard,
  FiEdit3,
  FiFolder,
  FiGrid,
  FiLogOut,
  FiPlus,
  FiSettings
}=FiIcons;

function getInitials(name='') {
  const words=name.trim().split(/\s+/).filter(Boolean);

  if (!words.length) {
    return 'DP';
  }

  return words.slice(0,2).map((word)=> word[0]).join('').toUpperCase();
}

function formatRole(role) {
  if (!role) {
    return 'Member';
  }

  return role.charAt(0).toUpperCase()+role.slice(1);
}

function Sidebar({
  brands,
  brandsLoading,
  brandsError,
  activeBrand,
  screen,
  user,
  role,
  onBrandChange,
  onNavigate,
  onAddBrand,
  onEditBrand,
  onSignOut
}) {
  const displayName=user?.name || 'Your account';
  const initials=getInitials(user?.name);

  return (
    <aside className="sidebar">
      <button className="wordmark" onClick={()=> onNavigate('create')}>
        <span className="wordmark-mark">D</span>
        <span>DalePost</span>
      </button>

      <div className="workspace-label">Workspace</div>

      {brandsLoading ? (
        <div className="brand-picker brand-picker-loading">
          <span>Loading brands…</span>
        </div>
      ) : brands.length === 0 ? (
        <div className="brand-picker brand-picker-empty">
          <p>No brands yet.</p>
          <button type="button" onClick={onAddBrand}>
            <SafeIcon icon={FiPlus} />
            Create your first brand
          </button>
        </div>
      ) : (
        <>
      <div className="brand-picker">
        <span
          className="brand-avatar"
          style={{background:activeBrand.primary}}
        >
          {activeBrand.logo ? (
            <img src={activeBrand.logo} alt="" />
          ) : activeBrand.monogram}
        </span>
        <select
          value={activeBrand.id}
          onChange={(event)=> onBrandChange(event.target.value)}
          aria-label="Select brand"
        >
          {brands.map((brand)=> (
            <option key={brand.id} value={brand.id}>
              {brand.name}
            </option>
          ))}
        </select>
        <SafeIcon icon={FiChevronDown} />
      </div>

      <div className="brand-picker-actions">
        <button
          className={screen==='brand-setup' ? 'active' : ''}
          onClick={onEditBrand}
        >
          <SafeIcon icon={FiSettings} />
          Edit brand
        </button>
        <button onClick={onAddBrand}>
          <SafeIcon icon={FiPlus} />
          Add new
        </button>
      </div>
        </>
      )}

      {brandsError && (
        <p className="brand-picker-error" role="alert">{brandsError}</p>
      )}

      <nav className="side-nav" aria-label="Main navigation">
        <button
          className={screen==='create' ? 'active' : ''}
          onClick={()=> onNavigate('create')}
        >
          <SafeIcon icon={FiEdit3} />
          Create post
        </button>
        <button
          className={screen==='library' ? 'active' : ''}
          onClick={()=> onNavigate('library')}
        >
          <SafeIcon icon={FiGrid} />
          Post library
        </button>
        <button
          className={screen==='assets' ? 'active' : ''}
          onClick={()=> onNavigate('assets')}
        >
          <SafeIcon icon={FiFolder} />
          Asset library
        </button>
        <button
          className={screen==='calendar' ? 'active' : ''}
          onClick={()=> onNavigate('calendar')}
        >
          <SafeIcon icon={FiCalendar} />
          Calendar
        </button>
        <button
          className={screen==='learnings' ? 'active' : ''}
          onClick={()=> onNavigate('learnings')}
        >
          <SafeIcon icon={FiBookOpen} />
          Learnings
        </button>
        <button
          className={screen==='connections' ? 'active' : ''}
          onClick={()=> onNavigate('connections')}
        >
          <SafeIcon icon={FiSettings} />
          Settings
        </button>
        <button
          className={screen==='billing' ? 'active' : ''}
          onClick={()=> onNavigate('billing')}
        >
          <SafeIcon icon={FiCreditCard} />
          Billing
        </button>
      </nav>

      <div className="brand-note">
        <span>Brand voice</span>
        <p>{activeBrand.voice}</p>
        <div className="color-row">
          <i style={{background:activeBrand.primary}} />
          <i style={{background:activeBrand.accent}} />
          <small>Brand palette</small>
        </div>
      </div>

      <button
        type="button"
        className={`profile profile-button ${screen==='team' ? 'active' : ''}`}
        onClick={()=> onNavigate('team')}
        aria-label="Open team settings"
      >
        <div className="profile-avatar">{initials}</div>
        <div>
          <strong>{displayName}</strong>
          <span>{formatRole(role)} · Manage team</span>
        </div>
      </button>

      <button
        type="button"
        className="sign-out-button"
        onClick={onSignOut}
      >
        <SafeIcon icon={FiLogOut} />
        Sign out
      </button>
    </aside>
  );
}

export default Sidebar;